import { Award, AwardDto } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useAvailableProgrammeAwards = (
  programmeId: string,
  options?: Omit<UseQueryOptions<Award[], Error>, 'queryKey' | 'queryFn'>,
): UseQueryResult<Award[], Error> => {
  return useQuery<Award[], Error>(
    queryKeys.availableProgrammeAwards(programmeId),
    () => coreService.getAllAvailableProgrammeAwards(programmeId),
    {
      enabled: !!programmeId,
      ...options,
    },
  )
}

export const useProgrammeAwardsByProgramme = (
  programmeId: string,
  options?: Omit<UseQueryOptions<AwardDto[], Error>, 'queryKey' | 'queryFn'>,
): UseQueryResult<AwardDto[], Error> => {
  return useQuery<AwardDto[], Error>(
    queryKeys.programmeAwardsByProgramme(programmeId),
    () => coreService.getMyProgrammeAwardsByProgramme(programmeId),
    {
      enabled: !!programmeId,
      ...options,
    },
  )
}
